import { FC, cloneElement } from 'react';

import { InfoCircle } from '@zooplus/icons';

interface Props {
  infoMessageIcon?: React.ReactNode;
  infoMessage?: React.ReactNode;
  errorMessageIcon?: React.ReactNode;
  errorMessage?: React.ReactNode;
  errorZta?: string;
  labelFor?: string;
}

const FormMessages: FC<Props> = ({
  infoMessage,
  errorMessage,
  infoMessageIcon,
  errorMessageIcon,
  errorZta,
  labelFor,
}) => {
  const infoClassName = 'z-form-message__icon';
  const errorClassName = 'z-form-message__icon z-form-message__icon--error';

  return (
    <div>
      {infoMessage && (
        <div className="z-form-message">
          <i className="z-form-message__icon-wrap">
            {infoMessageIcon ? (
              cloneElement(infoMessageIcon as React.ReactElement, {
                className: infoClassName,
              })
            ) : (
              <InfoCircle className={infoClassName} />
            )}
          </i>
          <div className="z-form-message__text">{infoMessage}</div>
        </div>
      )}
      {errorMessage && (
        <div className="z-form-message">
          <i className="z-form-message__icon-wrap">
            {errorMessageIcon ? (
              cloneElement(errorMessageIcon as React.ReactElement, {
                className: errorClassName,
              })
            ) : (
              <InfoCircle className={errorClassName} />
            )}
          </i>
          <div
            id={`${labelFor}-error-message`}
            data-zta={errorZta}
            className="z-form-message__text">
            {errorMessage}
          </div>
        </div>
      )}
    </div>
  );
};

export default FormMessages;
